import { jsxs as r, jsx as y, Fragment as p } from "react/jsx-runtime";
import u, { forwardRef as H, createElement as a } from "react";
import { c as b } from "../clsx-OuTLNxxd.js";
import "../Input.css?__remix_sideEffect__";const W = "320px",_ = "600px",S = "1025px",z = "_isVisuallyHidden_1d9hy_52",I = "_Input_1d9hy_64",k = "_error_1d9hy_89",B = "_InputWrapper_1d9hy_96",w = "_ErrorIcon_1d9hy_101",E = "_ErrorMessage_1d9hy_112",o = {
    mobile: W,
    "mobile-wide": "480px",
    tablet: _,
    "tablet-wide": "800px",
    desktop: S,
    "desktop-mid": "1281px",
    "desktop-large": "1360px",
    "heading-l": "--cxy-fontSize-xxxxl, --cxy-lineHeight-xxl, --cxy-fontWeight-extraBold",
    "heading-l-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-extraBold",
    "heading-m": "--cxy-fontSize-xxxl, --cxy-lineHeight-xxl, --cxy-fontWeight-semiBold",
    "heading-m-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-semiBold",
    "heading-s": "--cxy-fontSize-xxl, --cxy-lineHeight-xl, --cxy-fontWeight-extraBold",
    "subHeading-l": "--cxy-fontSize-xl, --cxy-lineHeight-l, --cxy-fontWeight-bold",
    "subHeading-m": "--cxy-fontSize-l, --cxy-lineHeight-xs, --cxy-fontWeight-normal",
    "subHeading-m-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-light",
    "subHeading-s": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
    "subHeading-s-mobile": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-semiBold",
    "button-m": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
    "button-s": "--cxy-fontSize-s, --cxy-lineHeight-xs, --cxy-fontWeight-semiBold",
    "button-xs": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-normal",
    "button-xxs": "--cxy-fontSize-xs, --cxy-lineHeight-xxs, --cxy-fontWeight-semiBold",
    "text-m": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
    "text-s": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-normal",
    "text-xs": "--cxy-fontSize-xs, --cxy-lineHeight-m, --cxy-fontWeight-semiBold",
    "text-xxs": "--cxy-fontSize-xs, --cxy-lineHeight-xxxs, --cxy-fontWeight-normal",
    isVisuallyHidden: z,
    Input: I,
    error: k,
    InputWrapper: B,
    ErrorIcon: w,
    ErrorMessage: E
  };
/**
 * @license lucide-react v0.367.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
var N = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
};
/**
 * @license lucide-react v0.367.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const C = (t) => t.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
/**
 * @license lucide-react v0.367.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const A = (t, l) => {
  const e = H(
    ({
      color: c = "currentColor",
      size: i = 24,
      strokeWidth: n = 2,
      absoluteStrokeWidth: x,
      className: g = "",
      children: s,
      ...h
    }, d) => a(
      "svg",
      {
        ref: d,
        ...N,
        width: i,
        height: i,
        stroke: c,
        strokeWidth: x ? Number(n) * 24 / Number(i) : n,
        className: ["lucide", `lucide-${C(t)}`, g].join(" "),
        ...h
      },
      [
      ...l.map(([m, f]) => a(m, f)),
      ...(Array.isArray(s) ? s : [s])]

    )
  );
  return e.displayName = `${t}`, e;
};
/**
 * @license lucide-react v0.367.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const v = A("CircleAlert", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["line", { x1: "12", x2: "12", y1: "8", y2: "12", key: "1pkeuh" }],
  ["line", { x1: "12", x2: "12.01", y1: "16", y2: "16", key: "4dfq90" }]]
  ),$ = u.forwardRef(
    ({ className: t, type: l, errors: e, ...c }, i) => {
      const n = e && (e == null ? void 0 : e.length) > 0;
      return /* @__PURE__ */r("div", { className: o.InputWrapper, children: [
        /* @__PURE__ */y(
          "input",
          {
            type: l,
            className: b(
              o.Input,
              n ? o.error : "",
              t
            ),
            ref: i,
            ...c
          }
        ),
        n && /* @__PURE__ */r(p, { children: [
          /* @__PURE__ */y(v, { className: o.ErrorIcon }),
          e == null ? void 0 : e.map((x) => /* @__PURE__ */y("p", { className: o.ErrorMessage, children: x }, x))]
        })]
      });
    }
  );
$.displayName = "Input";
export {
  $ as Input };